import { FocusableOption } from '@angular/cdk/a11y';
import { Component, ContentChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-list-item',
  host: {
    tabindex: '-1',
    role: 'listitem',
  },
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
})
export class ListItemComponent implements FocusableOption {
  @ContentChild('anchorEl') anchorEl: ElementRef;

  focus() {
    this.anchorEl.nativeElement.focus();
  }
}
